import React from 'react'

const styles = {
  text: {
    color: '#505050',
    fontSize: '14px',
  },
  icon: {
    marginBottomt: '-4px',
  },
}
export const TextHintWithIcon = ({ text, icon }) => {
  return (
    <div style={styles.container}>
      <p style={styles.text}>
        {text} (
        <span
          style={{
            display: 'inline-block',
            width: '1em',
            height: '1em',
            verticalAlign: 'middle',
            backgroundImage: icon,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: 3,
          }}
        />
        )
      </p>
    </div>
  )
}

export default TextHintWithIcon
